import React from "react";
import { MainContextInterface } from "./SharedModel";

const defaultState = {
  loadersList: [],
  modifyLoaders: () => {},
};

const MainContext = React.createContext<MainContextInterface>(defaultState);

export { MainContext };
